import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  // document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  // const hasToken = getToken()
  const hasToken = true

  if (hasToken) {
    if(to.name!=="Detail"){
      document.querySelector('meta[name="keywords"]').setAttribute('content', "2024佛山潭洲陶瓷展,潭洲陶瓷展,陶瓷展,装备展,潭洲展会,陶瓷与卫浴,陶瓷装备与材料,陶瓷产品展览会");
      document.querySelector('meta[name="description"]').setAttribute('content',"2024年，佛山潭洲国际会展中心，10大主题展馆，12万㎡展览面积，15万专业买家！一年一度的陶瓷界盛会,诚邀业界同仁参展观展!");
      // document.querySelector('meta[name="keywords"]').setAttribute('content', "Uniceramics Expo 2022, Uniceramics Expo, ceramics products expo, ceramics technology expo, ceramics and bathroom products, ceramics equipment and materials, ceramics products fair");
      // document.querySelector('meta[name="description"]').setAttribute('content',"20-24 July 2022, Tanzhou international convention and exhibition center, Foshan, 10 halls, 120000m2 exhibit space, 150000 professional buyers! An annual ceramics event, we sincerely invite ceramics peers to participate in the Expo!");
    }
    if (to.path === '/login') {
      // 已经登陆，跳转至首页
      next({ path: '/' })
      NProgress.done()
    } else {
      // const hasGetUserInfo = store.getters.name
      // if (hasGetUserInfo) {
      //   next()
      // } else {
      //   try {
      //     // get user info
      //     await store.dispatch('user/getInfo')

      //     next()
      //   } catch (error) {
      //     // remove token and go to login page to re-login
      //     await store.dispatch('user/resetToken')
      //     Message.error(error || 'Has Error')
      //     next(`/login?redirect=${to.path}`)
      //     NProgress.done()
      //   }
      // }
      next()
    }
  } else {
    //has no token

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
